<template>
  <div
    v-show="isVisible"
    class="time-schedule"
    :style="courseStyle"
  >
    <div class="course-name">
      {{ childCourse.parent_course.name }}
    </div>
    <div class="subtitle">
      <div
        v-show="showCourseTime"
        class="time"
        :style="subFontStyle"
      >
        {{ presentClassTime }}
      </div>
      <div
        v-show="showInstructors"
        class="time"
        :style="subFontStyle"
      >
        {{ presentInstructorNames }}
      </div>
    </div>
  </div>
</template>

<script>
import dateFns from "date-fns";
import { mapGetters } from "vuex";
import HourMinutes from "./hourMinutes";

export default {
	name: "ChildCourse",
	props: {
		childCourse: {},
		blockStart: {},
		blockEnd: {},
		blockHeight: {},
		showCourseTime: {},
		showInstructors: {},
		invisibleParentCourses: {},
		dayOfWeekVisible: {},
		fontSize: {},
		subFontSize: {},
	},
	data() {
		return {};
	},
	watch: {
		childCourse: {
			deep: true,
			immediate: true,
			handler() {
				this.$emit("init", {
					childCourse: this.childCourse,
					isVisible: true,
				});
			},
		},
	},
	computed: {
		...mapGetters(["getInstructorByIds", "getParentCourseCategories"]),
		courseStart() {
			return new HourMinutes(this.childCourse.start);
		},
		courseEnd() {
			return new HourMinutes(
				dateFns.addMinutes(this.childCourse.start, this.childCourse.duration)
			);
		},
		isVisible() {
			const isVisible =
				!this.blockStart.isAfter(this.courseStart) &&
				!this.blockEnd.isBefore(this.courseEnd) &&
				!this.invisibleParentCourses.includes(
					this.childCourse.parent_course.id
				) &&
				!this.dayOfWeekVisible.includes(
					dateFns.format(this.childCourse.dt, "YYYY-MM-DD")
				);

			this.$emit("init", {
				childCourse: this.childCourse,
				isVisible,
			});

			return isVisible;
		},
		blockDifference() {
			return this.blockEnd.toMinutes() - this.blockStart.toMinutes();
		},
		topDifference() {
			return (
				((this.courseStart.toMinutes() - this.blockStart.toMinutes()) /
					this.blockDifference) *
				this.blockHeight
			);
		},
		courseHeight() {
			let endTime = this.courseEnd.toMinutes();

			if (endTime === 0) {
				endTime = 24 * 60;
			}

			return (
				((endTime - this.courseStart.toMinutes()) / this.blockDifference) *
				this.blockHeight
			);
		},
		courseStyle() {
			return {
				height: this.courseHeight + "px",
				top: this.topDifference + "px",
				borderLeftColor: this.childCourse.parent_course.color,
				fontSize: `${this.fontSize}%`,
			};
		},
		subFontStyle() {
			return {
				fontSize: `${this.subFontSize}%`,
			};
		},
		presentInstructorNames() {
			return this.getInstructorByIds(this.childCourse.instructors)
				.map(instructor => {
					return instructor ? instructor.name : null;
				})
				.filter(item => item)
				.join(", ");
		},
		presentClassTime() {
			return `${dateFns.format(
				this.childCourse.dt,
				"HH:mm"
			)} - ${dateFns.format(
				dateFns.addMinutes(this.childCourse.dt, this.childCourse.duration),
				"HH:mm"
			)}`;
		},
	},
	methods: {},
};
</script>

<style lang="scss">
.time-schedule {
	position: absolute;
	color: #4a4a4a;

	width: 100%;
	left: 0;

	background-color: #ffffff;
	border-radius: 3px;
	border-left: 3px solid #224ba2;
	padding: 0 6px;
	box-sizing: border-box;

	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 16px;

	.course-name {
		text-align: center;
		font-size: 100%;
		line-height: 120%;
		font-weight: bold;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
	}

	.subtitle {
		width: 100%;
		font-size: 12px;
		line-height: 14px;
		font-weight: normal;
	}

	.time {
		width: 100%;
		line-height: 110%;
		padding-top: 2px;
		padding-right: 1px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		text-align: center;
	}
}
</style>
